<script>
 export function clickOutside(node) {
  
  const handleClick = event => {
      if (node && !node.contains(event.target) && !event.defaultPrevented) {
          node.dispatchEvent(
              new CustomEvent('click_outside', node)
          )
      }
  }

  document.addEventListener('click', handleClick, true);

  return {
      destroy() {
          document.removeEventListener('click', handleClick, true);
          }
      }
  }

  import { policy } from './stores6'

  const closePolicy = () => {
        policy.set(false)
    }
</script>

<div>
    <div class="policy" use:clickOutside on:click_outside={closePolicy}>
        <p style="font-size:25px; font-weight:700; padding:10px 0 30px 0;">プライバシーポリシー</p>
        <p>当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を使用しています。このGoogleアナリティクスはデータの収集のためにCookieを使用しています。このデータは匿名で収集されており、個人を特定するものではありません。<br>この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。この規約に関しての詳細はGoogleアナリティクスサービス利用規約のページやGoogleポリシーと規約ページをご覧ください。</p>
    </div>
</div>

<style>
div{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(100, 100, 100, 0.5);
    z-index:30;
}
div.policy{
    position:absolute;
    top:50%;
    left:50%;
    -webkit-transform : translate(-50%,-50%) rotateY(0deg);
    transform : translate(-50%,-50%) rotateY(0deg);
    -webkit-transition: transform .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition:transform .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    background-color: #ffffff;
    width:300px;
    height:300px;
    padding:20px;
}
p{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
</style>